// extracted by mini-css-extract-plugin
export default {"toc":"BlogTOC-module--toc--f088a","active":"BlogTOC-module--active--3eeac"};